import {FaLocationPin, FaShield} from "react-icons/fa6";
import {
    FaCar,
    FaCloudSun,
    FaLayerGroup,
    FaVideo,
    FaWaze
} from "react-icons/fa";
import {vehicleIcon} from "../../../../components/vehicle-icon/vehicle-icon.js";

const BASENAME = import.meta.env.BASE_URL;

const GisUtils = {
    getPriority: (type, alarm) => {
        if (alarm) return 4;

        const priority = {
            'garrison': 3,
            'capturePlace': 2,
            'attendance': 1,
            'point': 4,
            'sos': 5,
        }

        return priority[type] ?? 0;
    },

    getEventsCount: (events) => {
        const eventTypes = ['attendance', 'sos', 'capturePlace', 'contactid'];

        let count = eventTypes.reduce((acc, type) => {
            acc[type] = 0;
            return acc;
        }, {});

        [...events].filter(([, event]) => {
            switch (event.type) {
                case "attendance": return  event.icon === "onHold"
                case "capturePlace":
                case "contactid": return !!event.alarm
                default: return true
            }
        }).forEach(([, event]) => {
            if (count.hasOwnProperty(event.type)) {
                if (typeof count[event.type] === 'number') {
                    count[event.type] += 1;
                    if (count[event.type] > 99) count[event.type] = '+99';
                }
            }
        });

        return count;
    },

    getGroupName: (group) => {
        const groupName = {
            'garrison': 'Guarnição',
            'capturePlace': 'Câmeras de OCR',
            'attendance': 'Atendimento',
            'vms': 'Câmeras de vídeo',
            'contactid': 'Monitoramento patrimonial',
            'point': 'Georreferenciamento - Pontos',
            'zone': 'Georreferenciamento - Setores',
            'tracker': 'Rastreamento',
            'janitorial': 'Zeladoria',
            'weather': 'Clima',
            'waze': 'Waze',
            'sos': 'SOS',
        }

        return groupName[group] ?? "";
    },

    getGroupIcon: (group, config = false) => {
        const groupName = {
            'attendance': <i className="sw icon-sw-attendance"></i>,
            'garrison': <i className="sw icon-sw-garrison"></i>,
            'sos': <FaShield className={"sw"}/>,
            'janitorial': config ? <i className="sw icon-sw-cone-white"></i> : <i className="sw icon-sw-cone"></i>,
            'capturePlace': <i className="sw icon-sw-captureplace"></i>,
            'vms': <FaVideo className={"sw"}/>,
            'contactid': <i className="sw icon-sw-contactid"></i>,
            'point': <FaLocationPin className={"sw"}/>,
            'zone': <FaLayerGroup className={"sw"}/>,
            'waze': <FaWaze className={"sw waze"}/>,
            'tracker': <i className="sw icon-sw-tracker"></i>,
            'weather': <FaCloudSun className={"sw"}/>,
        };

        return groupName[group] ?? "";
    },

    getIconVehicleType: (type) => {
        const VehicleIcon = vehicleIcon[type] ?? FaCar;

        return <VehicleIcon />;
    },

    openMosaicCameras: (cameras) => {
        const camerasToOpen = cameras.map(camera => {
            return {id: camera.id, vmsId:camera?.vmsId}
        });

        localStorage.setItem("video-cameras", JSON.stringify(camerasToOpen));
        window.open(`${BASENAME}mosaic`, "mosaic");
    },

    getFromLocalStorage: (key) => {
        const value = localStorage.getItem(key);

        if (value) return JSON.parse(value).status;

        return false;
    },

    getStyles: (state, option) => {

        const {neighborhoodStreets, pointsOfInterest} = state;

        return [
            {
                "elementType": 'labels', "stylers": [
                    {
                        "visibility": option !== "RESET" ? option === "POI" ? neighborhoodStreets ? 'on' : 'off' : !neighborhoodStreets ? 'on' : 'off' : 'off'
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": option !== "RESET" ? option === "POI" ? !pointsOfInterest ? 'on' : 'off' : pointsOfInterest ? 'on' : 'off' : 'off'
                    }
                ]
            },

            {
                "featureType": "road",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "visibility": option !== "RESET" ? option === "POI" ? neighborhoodStreets ? 'on' : 'off' : !neighborhoodStreets ? 'on' : 'off' : 'off'
                    }
                ]
            },
        ]
    },

    resetZoom: (map, mapGeoItems, mapMarkers) => {
        const currentBounds = new google.maps.LatLngBounds();

        if (mapGeoItems) {
            for (const [, marker] of mapGeoItems.entries()) {
                if (marker.visible) {
                    currentBounds.extend(new google.maps.LatLng(marker.latitude, marker.longitude));
                }
            }
        }

        for (const [, marker] of mapMarkers.entries()) {
            if (marker.visible) {
                currentBounds.extend(new google.maps.LatLng(marker.latitude, marker.longitude));
            }
        }

        map.fitBounds(currentBounds);
    },

    vmsCameraIcon: (color) => {
        const hex = {
            "B46900": "brown",
            "FF7D96": "pink",
            "AF52DE": "purple",
            "00C7BE": "sea-green"
        }

        return hex[color];
    }
};

export default GisUtils;
